import React from 'react';
import { BookOpen, Sprout, Building2, LayoutGrid } from 'lucide-react';

const WhoWePartnerWith = () => {
  const partners = [
    {
      title: "Educational Institutes and RPTOs",
      description: "Universities, colleges, aviation institutes, and skill development centres that want to offer DGCA certified drone pilot training programs through Aerobott's recognised RPTO framework.",
      icon: <BookOpen className="w-8 h-8 text-blue-400" />
    },
    {
      title: "Agri-Businesses and Farm Networks",
      description: "Agricultural companies, farmer producer organisations, and agri-tech firms that want to integrate drone spraying, crop monitoring, and precision agriculture services for their farmers and clients.",
      icon: <Sprout className="w-8 h-8 text-green-400" />
    },
    {
      title: "Infrastructure and Survey Companies",
      description: "Civil engineering firms, GIS companies, infrastructure contractors, and government agencies that want to deploy drone-based surveying, mapping, and inspection capabilities through Aerobott.",
      icon: <Building2 className="w-8 h-8 text-purple-400" />
    },
    {
      title: "Drone Distributors and Resellers",
      description: "Companies and individuals who want to distribute or resell Aerobott's drone products — FLYT-I, Survey Master Pro, and Aero Agri — across their region or industry vertical.",
      icon: <LayoutGrid className="w-8 h-8 text-orange-400" />
    }
  ];

  return (
    <section className="bg-black py-20 px-4 sm:px-6 lg:px-16" id="who-we-partner-with">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-5xl font-raleway font-medium text-[#d5dbe6] mb-6">
            Who We Partner With
          </h2>
          <div className="w-20 h-1.5 bg-blue-600 mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          {partners.map((partner, index) => (
            <div 
              key={index}
              className="group relative bg-zinc-900/40 backdrop-blur-sm border border-zinc-800 rounded-3xl p-8 lg:p-10 transition-all duration-300 hover:bg-zinc-800/60 hover:border-blue-500/50 hover:-translate-y-2"
            >
              <div className="mb-6 inline-flex items-center justify-center p-4 bg-zinc-800/80 rounded-2xl group-hover:scale-110 transition-transform duration-300">
                {partner.icon}
              </div>
              <h3 className="text-xl lg:text-2xl font-raleway font-semibold text-white mb-4">
                {partner.title}
              </h3>
              <p className="text-gray-400 font-raleway leading-relaxed text-sm lg:text-base">
                {partner.description}
              </p>
              
              {/* Decorative gradient corner */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-tr-3xl"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWePartnerWith;
